/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react'
import {
  ModernModalBackdrop,
  ModernVerticalModal,
  ModalFieldGroup,
  ModalLabel,
  ModalInput,
  ModalSelect,
  SubmitButton,
} from '../../../styles/Modal'
import api from '../../../services/axios'
import { Campo, CampoDelimitado } from '../../../types/campos'
import { IoCloseCircleSharp, IoArrowBack } from 'react-icons/io5'
import { IoColorWandOutline } from 'react-icons/io5'
import ModalLayoutAssistant from '../ModalLayoutAssistant'

interface ModalDistPropsPosicao extends ModalDistPropsGestor {
  layout: 'posicao'
  cliente: Campo[]
  setCliente: React.Dispatch<React.SetStateAction<Campo[]>>
  sellout: Campo[]
  setSellout: React.Dispatch<React.SetStateAction<Campo[]>>
  produtos: Campo[]
  setProdutos: React.Dispatch<React.SetStateAction<Campo[]>>
  estoque: Campo[]
  setEstoque: React.Dispatch<React.SetStateAction<Campo[]>>
  forcaven: Campo[]
  setForcaven: React.Dispatch<React.SetStateAction<Campo[]>>
}

interface ModalDistPropsDelimitado extends ModalDistPropsGestor {
  layout: 'delimitador'
  cliente: CampoDelimitado[]
  setCliente: React.Dispatch<React.SetStateAction<CampoDelimitado[]>>
  sellout: CampoDelimitado[]
  setSellout: React.Dispatch<React.SetStateAction<CampoDelimitado[]>>
  produtos: CampoDelimitado[]
  setProdutos: React.Dispatch<React.SetStateAction<CampoDelimitado[]>>
  estoque: CampoDelimitado[]
  setEstoque: React.Dispatch<React.SetStateAction<CampoDelimitado[]>>
  forcaven: CampoDelimitado[]
  setForcaven: React.Dispatch<React.SetStateAction<CampoDelimitado[]>>
}

interface ModalDistPropsGestor {
  name: string
  phone: string
  setName: (text: string) => void
  envio: string
  setEnvio: (text: string) => void
  codDist: string
  setCodDist: (text: string) => void
  visualizador: string
  setVisualizador: (text: string) => void
  status: string
  setStatus: (text: string) => void
  cnpj: string
  setCnpj: (text: string) => void
  fantasyName: string
  setFantasyName: (text: string) => void
  response: string
  regional: string
  setRegional: (text: string) => void
  email: string
  setEmail: (text: string) => void
  setResponse: (text: string) => void
  gestor: string
  setGestor: (text: string) => void
  typeFile: string
  setTypeFile: (text: string) => void
  layout: '' | 'posicao' | 'delimitador' | 'mtrix'
  setLayout: React.Dispatch<React.SetStateAction<'' | 'posicao' | 'delimitador' | 'mtrix'>>
  loading: boolean
  handleClick: () => void
  setCloseModal: () => void
  handlePhoneChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleBack?: () => void
}

type ModalDistProps = ModalDistPropsPosicao | ModalDistPropsDelimitado

function ModalDist(props: ModalDistProps) {
  const {
    cnpj,
    gestor,
    name,
    fantasyName,
    typeFile,
    loading,
    setName,
    setCnpj,
    setGestor,
    setFantasyName,
    response,
    layout,
    setLayout,
    setTypeFile,
    setResponse,
    handleClick,
    setCloseModal,
    phone,
    email,
    codDist,
    setCodDist,
    setVisualizador,
    visualizador,
    setEmail,
    envio,
    setEnvio,
    handlePhoneChange,
    regional,
    setRegional,
    setStatus,
    status,
    handleBack,
  } = props

  const [gestores, setGestores] = useState<
    {
      id: string
      name: string
      codigo: string
      role: string
    }[]
  >([])

  const [openAssistant, setOpenAssistant] = useState(false)

  const {
    sellout = [],
    setSellout,
    estoque = [],
    setEstoque,
    produtos = [],
    setProdutos,
    forcaven = [],
    setForcaven,
    cliente = [],
    setCliente,
  } = props as any

  useEffect(() => {
    const fetchGestores = async () => {
      try {
        const { data } = await api.get('/users')
        setGestores(data)
      } catch (err) {
        console.error('Erro ao carregar gestores:', err)
      }
    }

    fetchGestores()
  }, [])

  const handleApplyAssistantLayout = (tipo: string, camposMapeados: any[]) => {
    if (tipo === 'vendas' && setSellout) setSellout(camposMapeados)
    if (tipo === 'estoque' && setEstoque) setEstoque(camposMapeados)
    if (tipo === 'produtos' && setProdutos) setProdutos(camposMapeados)
    if (tipo === 'forcavenda' && setForcaven) setForcaven(camposMapeados)
    if (tipo === 'clientes' && setCliente) setCliente(camposMapeados)
  }

  function formatCNPJ(cnpjStr: string): string {
    return cnpjStr
      .replace(/\D/g, '')
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2')
      .slice(0, 18)
  }

  return (
    <>
      <ModernModalBackdrop>
      <ModernVerticalModal>
        <div className="header">
          {handleBack && (
            <button className="btn-back" onClick={handleBack} type="button">
              <IoArrowBack />
            </button>
          )}
          <h3>Cadastro de Distribuidor</h3>
          <button className="btn-close" onClick={setCloseModal} type="button">
            <IoCloseCircleSharp />
          </button>
        </div>

        <div className="body">
          <p className="form-section-title">Dados Gerais</p>

          <ModalFieldGroup>
            <ModalLabel>Usuário / Fantasia</ModalLabel>
            <ModalInput
              type="text"
              value={fantasyName}
              onChange={(e) => setFantasyName(e.target.value)}
              placeholder="Nome do usuário ou fantasia"
            />
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>Razão Social</ModalLabel>
            <ModalInput
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Razão social da distribuidora"
            />
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>CNPJ</ModalLabel>
            <ModalInput
              type="text"
              value={formatCNPJ(cnpj)}
              onChange={(e) => {
                const clean = e.target.value.replace(/\D/g, '')
                setCnpj(clean)
              }}
              maxLength={18}
              placeholder="00.000.000/0000-00"
            />
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>Código Distribuidor</ModalLabel>
            <ModalInput
              type="text"
              value={codDist}
              onChange={(e) => setCodDist(e.target.value)}
              placeholder="Código interno GSA"
            />
          </ModalFieldGroup>

          <p className="form-section-title">Contato Responsável</p>

          <ModalFieldGroup>
            <ModalLabel>Pessoa Responsável</ModalLabel>
            <ModalInput
              type="text"
              value={response}
              onChange={(e) => setResponse(e.target.value)}
              placeholder="Nome do contato de retorno"
            />
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>E-mail</ModalLabel>
            <ModalInput
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Ex: contato@distribuidor.com"
            />
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>Telefone</ModalLabel>
            <ModalInput
              type="text"
              value={phone}
              onChange={handlePhoneChange}
              maxLength={15}
              placeholder="(00) 00000-0000"
            />
          </ModalFieldGroup>

          <p className="form-section-title">Configurações de Acesso</p>

          <ModalFieldGroup>
            <ModalLabel>Gestor Vinculado</ModalLabel>
            <ModalSelect
              value={gestor}
              onChange={(e) => setGestor(e.target.value)}
            >
              <option value="">Selecione um gestor</option>
              {gestores.map((g) => (
                <React.Fragment key={g.id}>
                  {g.role === 'gestor' && (
                    <option value={g.id}>
                      {g.codigo} - {g.name}
                    </option>
                  )}
                </React.Fragment>
              ))}
            </ModalSelect>
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>Visualizador</ModalLabel>
            <ModalSelect
              value={visualizador}
              onChange={(e) => setVisualizador(e.target.value)}
            >
              <option value="">Selecione um visualizador (Opcional)</option>
              {gestores.map((g) => (
                <React.Fragment key={g.id}>
                  {g.role === 'visualizador' && (
                    <option value={g.id}>
                      {g.name}
                    </option>
                  )}
                </React.Fragment>
              ))}
            </ModalSelect>
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>Tipo de Layout</ModalLabel>
            <ModalSelect
              value={layout}
              onChange={(e) => setLayout(e.target.value as 'posicao' | 'delimitador' | 'mtrix')}
            >
              <option value="">Selecione o layout</option>
              <option value="mtrix">Padrão Mtrix</option>
              <option value="posicao">Personalizado Posições</option>
              <option value="delimitador">Personalizado delimitador</option>
            </ModalSelect>

            {layout === 'posicao' && (
              <div style={{ marginTop: '8px' }}>
                <button
                  type="button"
                  onClick={() => setOpenAssistant(true)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    background: 'linear-gradient(135deg, #0284c7, #0369a1)',
                    border: '1px solid rgba(56, 189, 248, 0.4)',
                    color: '#ffffff',
                    fontSize: '12px',
                    fontWeight: 700,
                    padding: '10px 14px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    width: '100%',
                    boxShadow: '0 4px 12px rgba(2, 132, 199, 0.25)',
                    transition: 'all 0.2s',
                  }}
                >
                  <IoColorWandOutline style={{ fontSize: '18px', color: '#38bdf8' }} />
                  <span>🪄 Assistente de Layout TXT (Importar & Analisar)</span>
                </button>

                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '8px' }}>
                  <span
                    style={{
                      fontSize: '10px',
                      padding: '2px 8px',
                      borderRadius: '4px',
                      background: sellout.length > 0 ? 'rgba(34, 197, 94, 0.15)' : 'rgba(255, 255, 255, 0.05)',
                      color: sellout.length > 0 ? '#4ade80' : '#94a3b8',
                      border: '1px solid rgba(255, 255, 255, 0.08)',
                    }}
                  >
                    Vendas: {sellout.length > 0 ? `${sellout.length} campos` : 'Padrão'}
                  </span>
                  <span
                    style={{
                      fontSize: '10px',
                      padding: '2px 8px',
                      borderRadius: '4px',
                      background: estoque.length > 0 ? 'rgba(34, 197, 94, 0.15)' : 'rgba(255, 255, 255, 0.05)',
                      color: estoque.length > 0 ? '#4ade80' : '#94a3b8',
                      border: '1px solid rgba(255, 255, 255, 0.08)',
                    }}
                  >
                    Estoque: {estoque.length > 0 ? `${estoque.length} campos` : 'Padrão'}
                  </span>
                  <span
                    style={{
                      fontSize: '10px',
                      padding: '2px 8px',
                      borderRadius: '4px',
                      background: produtos.length > 0 ? 'rgba(34, 197, 94, 0.15)' : 'rgba(255, 255, 255, 0.05)',
                      color: produtos.length > 0 ? '#4ade80' : '#94a3b8',
                      border: '1px solid rgba(255, 255, 255, 0.08)',
                    }}
                  >
                    Produtos: {produtos.length > 0 ? `${produtos.length} campos` : 'Padrão'}
                  </span>
                  <span
                    style={{
                      fontSize: '10px',
                      padding: '2px 8px',
                      borderRadius: '4px',
                      background: forcaven.length > 0 ? 'rgba(34, 197, 94, 0.15)' : 'rgba(255, 255, 255, 0.05)',
                      color: forcaven.length > 0 ? '#4ade80' : '#94a3b8',
                      border: '1px solid rgba(255, 255, 255, 0.08)',
                    }}
                  >
                    Força Vendas: {forcaven.length > 0 ? `${forcaven.length} campos` : 'Padrão'}
                  </span>
                </div>
              </div>
            )}
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>Tipo de Envio</ModalLabel>
            <ModalInput
              type="text"
              value={envio}
              onChange={(e) => setEnvio(e.target.value)}
              placeholder="Ex: FTP, API, E-mail"
            />
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>Tipo de Importação</ModalLabel>
            <ModalSelect
              value={typeFile}
              onChange={(e) => setTypeFile(e.target.value)}
            >
              <option value="">Selecione o tipo de envio</option>
              <option value="automatico">Automático</option>
              <option value="manual">Manual</option>
            </ModalSelect>
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>Operação (Regional)</ModalLabel>
            <ModalInput
              type="text"
              value={regional}
              onChange={(e) => setRegional(e.target.value)}
              placeholder="Ex: Centro-Oeste, Norte"
            />
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>Status do Distribuidor</ModalLabel>
            <ModalSelect
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="">Selecione o status</option>
              <option value="1">Ativo</option>
              <option value="0">Inativo</option>
            </ModalSelect>
          </ModalFieldGroup>

          <SubmitButton type="button" onClick={handleClick} disabled={loading}>
            {loading ? 'Carregando...' : 'Criar Distribuidor'}
          </SubmitButton>
        </div>
      </ModernVerticalModal>
    </ModernModalBackdrop>

    <ModalLayoutAssistant
      isOpen={openAssistant}
      onClose={() => setOpenAssistant(false)}
      layoutsCadastrados={{
        vendas: sellout,
        estoque: estoque,
        produtos: produtos,
        forcavenda: forcaven,
        clientes: cliente,
      }}
      onApplyLayout={handleApplyAssistantLayout}
    />
  </>
  )
}

export default ModalDist
